import React, { Fragment, useEffect, useState } from 'react'
import { parse } from 'qs'
import Modal from '../../../components/Modal'
import Button from '../../../components/Button'
import { Select } from '../../../components/Form'
import Loader from '../../../components/Loader'
import { usePrevious } from '../../../utils/hooks'
import AlertTriangle from '../../../assets/img/alert-triangle-yellow.png'

const Inputs = props => {
  const {
    deliveryDays,
    deliveryTimes,
    selectedDeliveryTime,
    selectedDeliveryDay,
    changeSelectedDeliveryDay,
    changeSelectedDeliveryTime,
    selectedZipcode,
    setZipcode,
    getUpcomingDays,
    getTimeslots,
    getMenu,
    location,
    userIsLoggedIn,
    authChecked,
    addresses,
    selectedAddress,
    changeSelectedAddress,
    clearOrder,
    mealCount
  } = props

  const { zipcode: urlZipcode } = parse(location.search.slice(1))

  if (authChecked && !userIsLoggedIn && !selectedZipcode && !urlZipcode) {
    window.location.href = process.env.REACT_APP_SITE_BASE_URL
    return null
  }

  const previousDeliveryDay = usePrevious(selectedDeliveryDay)
  const previousZipcode = usePrevious(selectedZipcode)

  const [showAlert, setShowAlert] = useState(false)
  const [alertCallback, setAlertCallback] = useState({})

  const openAlert = cb => {
    setShowAlert(true)
    setAlertCallback({ confirm: cb })
  }

  const confirmAlert = () => {
    if (alertCallback.confirm) {
      alertCallback.confirm()
    }
    setShowAlert(false)
  }

  const closeAlert = () => {
    setShowAlert(false)
  }

  useEffect(() => {
    if (!selectedZipcode && urlZipcode) {
      setZipcode(urlZipcode)
    }
  }, [])

  useEffect(() => {
    if (selectedZipcode) {
      getTimeslots()
      getUpcomingDays().then(() => getMenu())
    }
  }, [selectedZipcode])

  useEffect(() => {
    if (selectedDeliveryDay && previousDeliveryDay) {
      getMenu()
    }
  }, [selectedDeliveryDay])

  useEffect(() => {
    if (previousDeliveryDay) {
      clearOrder()
    }
  }, [selectedDeliveryDay])

  useEffect(() => {
    if (previousZipcode) {
      clearOrder()
    }
  }, [selectedZipcode])

  if (!selectedDeliveryDay || !selectedDeliveryTime || !selectedZipcode) {
    return <Loader />
  }

  const addressLabel = userIsLoggedIn ? 'Address' : 'Zipcode'
  const _addresses_ = userIsLoggedIn ? addresses : [selectedZipcode]
  const _selectedAddress_ = userIsLoggedIn ? selectedAddress : selectedZipcode
  const changeAddress = address => {
    if (userIsLoggedIn) {
      changeSelectedAddress(address)
    }
  }

  return (
    <Fragment>
      <Modal
        title="Changes on Delivery Day"
        size="md"
        isOpen={showAlert}
        onRequestClose={closeAlert}>
        <div className="cookunity__delivery_day_alert">
          <img src={AlertTriangle} alt="alert" />
          <p>
            You have <strong>{mealCount} meals</strong> selected for your{' '}
            {selectedDeliveryDay.label} order that won't be available due to
            chef rotation so you would have to select new ones
          </p>
        </div>
        <Button large dark onClick={confirmAlert}>
          Confirm
        </Button>
        <Button large transparent onClick={closeAlert}>
          Cancel
        </Button>
      </Modal>
      <section className="cookunity__menu__inputs">
        <div>
          <p>Delivery Day</p>
          <Select
            isSearchable={false}
            options={deliveryDays}
            value={selectedDeliveryDay}
            onChange={newSelection => {
              const { date } = selectedDeliveryDay
              const { date: newDate } = newSelection

              const dateChanged = date !== newDate

              if (dateChanged) {
                if (mealCount) {
                  openAlert(() => changeSelectedDeliveryDay(newSelection))
                } else {
                  changeSelectedDeliveryDay(newSelection)
                }
              }
            }}
          />
        </div>

        <div>
          <p>Delivery Time</p>
          <Select
            isSearchable={false}
            options={deliveryTimes}
            value={selectedDeliveryTime}
            onChange={changeSelectedDeliveryTime}
          />
        </div>

        <div>
          <p>{addressLabel}</p>
          <Select
            isSearchable={false}
            options={_addresses_}
            value={_selectedAddress_}
            onChange={changeAddress}
          />
        </div>
      </section>
    </Fragment>
  )
}

export default Inputs



// WEBPACK FOOTER //
// ./src/modules/Menu/Inputs/Inputs.jsx